<template>
  <ion-page>
    <ion-header>
      <ion-toolbar color="dark">
        <ion-buttons slot="start">
          <div class="pl-05">
            <img src="@/assets/logo/assemble.png" width="30" />
          </div>
        </ion-buttons>
        <ion-buttons slot="primary">
          <ion-button @click="$router.replace('/tabs/settings')">
            <ion-icon slot="icon-only" :icon="settingsOutline"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-buttons slot="primary">
          <ion-button @click="$router.replace('/tabs/account')">
            <ion-icon slot="icon-only" :icon="personCircleOutline"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-title class="">{{ bannerTitle }}</ion-title>
      </ion-toolbar>
      <ion-list>
        <ion-item :lines="filterListShow ? 'full' : 'none'" class="filter-toggle-row">
          <ion-label>Filters</ion-label>
          <ion-button @click="toggleFilterList">{{ filterListShow ? 'Close' : 'Open' }}</ion-button>
        </ion-item>
        <div :class="`filter-list ${filterListShow ? '' : 'close'}`">
          <!-- <ion-list-header>
            <ion-label> Matches </ion-label>
          </ion-list-header> -->
          <ion-item >
            <ion-label>Season</ion-label>
            <ion-select placeholder="Select Season" interface="action-sheet" v-model="filterSeason" @ionChange="handleSeasonChange">
              <ion-select-option v-for="season in seasons" :key="get(season, '_id')" :value="get(season, '_id')">{{ get(season, '_id') }}</ion-select-option>
            </ion-select>
          </ion-item>
          <ion-item>
            <ion-label>Type</ion-label>
            <ion-select v-model="gameType" ok-text="Select" cancel-text="Clear" @ionCancel="() => gameType = undefined" :key="key" @ionChange="handleGameTypeChange" interface="action-sheet" placeholder="Filter Competitions By Type">
              <ion-select-option v-for="g in gameTypes" :key="g.type" :value="g.type">{{g.name}}</ion-select-option>
            </ion-select>
          </ion-item>
          <ion-item>
            <ion-label>
              Competition
              <ion-icon
                class="competition-order-info"
                :icon="informationCircleOutline"
                role="button"
                tabindex="0"
                aria-label="How is this list ordered?"
                @click.stop="openOrderInfo"
                @keydown.enter.stop="openOrderInfo"
              ></ion-icon>
            </ion-label>
            <ion-select
              v-model="competitionIds"
              placeholder="Filter by Competitions"
              :multiple="true"
              :interfaceOptions="customAlertOptions"
              ok-text="Select" cancel-text="Clear" @ionCancel="() => competitionIds = null"
              @ionChange="handleFilterChange('ion select competition', $event)"
            >
              <ion-select-option
                v-for="{ _id, name } in sortedCompetition"
                :key="_id"
                :value="_id"
                >{{ name }}</ion-select-option
              >
            </ion-select>
          </ion-item>
          <ion-popover :is-open="orderInfoOpen" :event="orderInfoEvent" @ionPopoverDidDismiss="orderInfoOpen = false">
            <ion-content class="ion-padding competition-order-info-popover">
              Competitions follow the order set in Settings &gt; Order Competitions, which also drives the
              matches list and LiveScores. Any sharing a position appear alphabetically.
              <br /><br />
              Only active competitions with fixtures are listed. A competition appears under every season
              it has matches in.
            </ion-content>
          </ion-popover>
          <ion-item>
            <ion-label>Filter Competition</ion-label>
            <ion-button @click="onFilter">Set Filter</ion-button>
          </ion-item>
          <ion-item lines="none">
            <ion-label>Round</ion-label>
            <ion-select v-model="round" ok-text="Select" cancel-text="Clear" @ionCancel="() => round = undefined" :key="key" @ionChange="handleFilterChange('ion select round')" interface="action-sheet" placeholder="Filter By Round">
              <ion-select-option v-for="i in rounds" :key="i" :value="i">{{i}}</ion-select-option>
            </ion-select>
          </ion-item>
          <!-- <ion-item lines="none" :key="key">
            <ion-label>Date</ion-label>
            <div class="date-picker-div">
              <VueDatePicker class="dateRangePicker" v-model="datePickerData" range
              :teleport="true"
              :enable-time-picker="false"
              @update:model-value="handleFilterChange('vue date picker')"
              />
            </div>
          </ion-item> -->
        </div>
      </ion-list>
    </ion-header>
    <ion-content>
      <div class="date-filter-chips">
        <ion-chip v-if="selectedDate" @click="clearDateSelect" class="selected-date-chip">
          {{ formatSelectedDate() }}
          <ion-icon :icon="closeCircle" class="clear-icon"></ion-icon>
        </ion-chip>
        <ion-chip @click="openDatePicker" class="date-select-chip">Select Date</ion-chip>
        <ion-chip @click="setDateFilter('yesterday')" :class="{ active: activeDateFilter === 'yesterday' }">Yesterday</ion-chip>
        <ion-chip @click="setDateFilter('today')" :class="{ active: activeDateFilter === 'today' }">Today</ion-chip>
        <ion-chip @click="setDateFilter('tomorrow')" :class="{ active: activeDateFilter === 'tomorrow' }">Tomorrow</ion-chip>
        <ion-chip @click="setDateFilter('next7days')" :class="{ active: activeDateFilter === 'next7days' }">Next 7 Days</ion-chip>
        <ion-chip @click="setDateFilter('nextMonth')" :class="{ active: activeDateFilter === 'nextMonth' }">Next Month</ion-chip>
        <small @click="clearDateSelect" class="clear-filters">Clear Filters</small>

        <div>Group Matches By:</div>
        <ion-chip @click="setMatchesView('competition')" :class="{ active: activeMatchesView === 'competition' }">Competition</ion-chip>
        <ion-chip @click="setMatchesView('date')" :class="{ active: activeMatchesView === 'date' }">Date</ion-chip>
        <ion-chip @click="setMatchesView('time')" :class="{ active: activeMatchesView === 'time' }">Time of Match</ion-chip>
        <ion-chip @click="setMatchesView('venue')" :class="{ active: activeMatchesView === 'venue' }">Venue</ion-chip>
        <ion-chip @click="setMatchesView('field')" :class="{ active: activeMatchesView === 'field' }">Field</ion-chip>
      </div>
      <VueDatePicker
        v-model="selectedDate"
        @update:model-value="onDateSelect"
        :enable-time-picker="false"
        :teleport="true"
        :auto-apply="true"
        :close-on-auto-apply="true"
        ref="datePicker"
        hide-input-icon
        input-class-name="hidden-input"
      />

      <ion-modal :keep-contents-mounted="true">
        <ion-datetime id="date-select" presentation="date" @ionChange="onDateSelect"></ion-datetime>
      </ion-modal>

      <div v-if="activeMatchesView === 'date'">
        <div v-for="(dayGroup, dayIndex) in groupedMatches" :key="`${dayIndex}-${key}`" class="mb-2">
          <div class="date-row">
            <div class="mb-10 normal-text">
              <ion-label>{{dayFormatter(dayGroup.date)}}</ion-label>
            </div>
          </div>
          <div v-for="(competitionGroup, compIndex) in dayGroup.competitions" :key="compIndex" class="competition-group">
            <div class="competition-header" @click="toggleCompetition(dayIndex, compIndex)">
              <div class="competition-title">
                <h3>{{ competitionGroup.name }}</h3>
                <ion-icon :icon="competitionGroup.isOpen !== false ? chevronUp : chevronDown" />
              </div>
            </div>
            <div v-if="competitionGroup.isOpen !== false" :key="`${dayIndex}-${compIndex}-${key}`">
              <ion-card v-for="match in competitionGroup.matches" :key="match._id" class="custom-card" @click="goMatch(match._id, match.homeTeam, match.awayTeam, match.meta, match.competition, match.competitionSettings)">
                <ion-card-content v-if="!match.meta.isBye">
                  <div class="match-row">
                    <div class="match-time ml-10">{{ moment(match.dateTime).format('HH:mm') }}</div>
                    <div class="match-round-group">
                      <div class="match-round">{{ getRoundLabel(match.round, match.meta) }}</div>
                      <div v-if="shouldShowCompetitionName(match)" class="match-competition text-gray">{{ get(match, 'competition.name', 'TBD') }}</div>
                    </div>
                    <div class="team-info home mr-20">
                      <div class="team-name">{{ get(match.homeTeam, 'name', 'TBD') }}</div>
                      <TeamLogo :team="match.homeTeam" class="team-logo" v-if="!matchIsVs(match)" />
                      <TeamLogoVs :team="match.homeTeam" class="team-logo" v-else />
                    </div>
                    <div class="match-status">
                      <div class="score-text">
                        {{ getScore('homeTeam', match.scoringEvents, match.scores, match.status, match.meta, match.homeTeam, match.competition._id) }} -
                        {{ getScore('awayTeam', match.scoringEvents, match.scores, match.status, match.meta, match.awayTeam, match.competition._id) }}
                      </div>
                      <ion-badge :color="gameStatusColor(match.status)" :class="gameStatusClass(match.status)">
                        <div v-if="gameStatusProgress(match.status)" class="dot"></div>
                        <p>{{ upperCase(match.status).replace('FIRST', '1st').replace('SECOND', '2nd').replace('THIRD', '3rd').replace('FOURTH', '4th') }}</p>
                      </ion-badge>
                      <div class="match-referees" v-if="hasReferees(match)">
                        <div>Referees:</div>
                        <div class="text-gray" v-for="referee in refereesToShow(match)" :key="get(referee, '_id')">
                          <span>{{ get(referee, 'firstName', '') }} {{ get(referee, 'lastName', '') }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="team-info away ml-20">
                      <TeamLogo :team="match.awayTeam" class="team-logo" v-if="!matchIsVs(match)" />
                      <TeamLogoVs :team="match.awayTeam" class="team-logo" v-else />
                      <div class="team-name">{{ get(match.awayTeam, 'name', 'TBD') }}</div>
                    </div>
                    <div class="match-venue ml-10 flex flex-column">
                      <!-- <span class="match-venue-text">Venue</span> -->
                      <span class="match-venue-name">{{ get(match.venue, 'name', 'N/A') }}</span>
                      <span class="match-venue-field text-gray">{{ fieldDisplayName(get(match, 'meta.field')) }}</span>
                    </div>
                  </div>

                  <!-- Mobile version -->
                  <div class="match-row-mobile">
                    <div class="teams-status">
                      <div class="team-info home">
                        <TeamLogo :team="match.homeTeam" class="team-logo" />
                        <div class="team-name">{{ get(match.homeTeam, 'name', 'TBD') }}</div>
                      </div>
                      <div class="match-status">
                        <div class="score-text">
                          {{ getScore('homeTeam', match.scoringEvents, match.scores, match.status, match.meta, match.homeTeam, match.competition._id) }} -
                          {{ getScore('awayTeam', match.scoringEvents, match.scores, match.status, match.meta, match.awayTeam, match.competition._id) }}
                        </div>
                        <ion-badge :color="gameStatusColor(match.status)" :class="gameStatusClass(match.status)">
                          <div v-if="gameStatusProgress(match.status)" class="dot"></div>
                          <p>{{ upperCase(match.status).replace('FIRST', '1st').replace('SECOND', '2nd').replace('THIRD', '3rd').replace('FOURTH', '4th') }}</p>
                        </ion-badge>
                        <div class="match-referees" v-if="hasReferees(match)">
                          <div>Referees:</div>
                          <div v-for="referee in refereesToShow(match)" :key="get(referee, '_id')">
                            <span>{{ get(referee, 'firstName', '') }} {{ get(referee, 'lastName', '') }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="team-info away">
                        <TeamLogo :team="match.awayTeam" class="team-logo" />
                        <div class="team-name">{{ get(match.awayTeam, 'name', 'TBD') }}</div>
                      </div>
                    </div>
                    <div class="match-details">
                      <div class="match-time">{{ moment(match.dateTime).format('HH:mm') }}</div>
                      <div class="match-round">{{ getRoundLabel(match.round, match.meta) }}</div>
                    </div>
                    <div v-if="shouldShowCompetitionName(match)" class="match-competition text-gray">{{ get(match, 'competition.name', 'TBD') }}</div>
                    <div class="match-venue">{{ get(match.venue, 'name', 'N/A') }}</div>
                    <div class="match-field text-gray">{{ fieldDisplayName(get(match, 'meta.field')) }}</div>
                  </div>
              </ion-card-content>
              </ion-card>
              <ion-card v-if="competitionGroup.byeMatches && competitionGroup.byeMatches.length > 0"  class="custom-card bye">
                <ion-card-content>
                  <ion-text><h4 class="round-text bye-text f-bold">BYES</h4></ion-text>
                  <div class="bye-teams-container">
                    <div v-for="byeItem in competitionGroup.byeMatches" :key="byeItem.team._id" class="bye-team clickable" @click="handleByeTeamClick(byeItem.match)">
                      <TeamLogo :team="byeItem.team" />
                      <div class="team-name light-text text-center mt-10">{{ get(byeItem.team, 'name', 'Unknown Team') }}</div>
                      <ion-badge v-if="byeItem.match.status === 'final'" :color="gameStatusColor(byeItem.match.status)" class="bye-status-badge mt-5">
                        {{ upperCase(byeItem.match.status) }}
                      </ion-badge>
                    </div>
                  </div>
                </ion-card-content>
              </ion-card>
            </div>
          </div>
        </div>
      </div>
      <div v-if="activeMatchesView === 'competition'">
        <!-- Grouped by competition view -->
        <div
          v-for="(groupedMatch, compIndex) in groupedMatchesByCompetitions"
          :key="`${compIndex}-${key}`"
          class="mb-2"
        >
          <div class="competition-group">
            <!-- <div class="competition-header">
              <div class="competition-title">
                <h3>{{ groupedMatch.competitionName }}</h3>
              </div>
            </div> -->

            <div class="competition-header" @click="toggleCompetitionGroup(groupedMatch.competitionName)">
              <div class="competition-title">
                <h3>{{ groupedMatch.competitionName }}</h3>
                <ion-icon :icon="getCompetitionGroupOpenState(groupedMatch.competitionName) ? chevronUp : chevronDown" />
              </div>
            </div>

            <div v-if="getCompetitionGroupOpenState(groupedMatch.competitionName)" :key="`${compIndex}-${key}`">

              <!-- Days for this competition -->
              <div
                v-for="(day, dayIdx) in groupedMatch.days"
                :key="`${compIndex}-${dayIdx}-${key}`"
                class="mb-2"
              >
                <div class="date-row date-row-comp">
                  <div class="mb-10 normal-text">
                    <ion-label>{{ dayFormatter(day.date) }}</ion-label>
                  </div>
                </div>

                <!-- Matches for the day -->
                <div v-for="match in day.matches" :key="match._id">
                  <ion-card class="custom-card" v-if="!match.meta.isBye" @click="goMatch(match._id, match.homeTeam, match.awayTeam, match.meta, match.competition, match.competitionSettings)">
                    <ion-card-content>
                      <div class="match-row">
                        <div class="match-time ml-10">{{ moment(match.dateTime).format('HH:mm') }}</div>
                        <div class="match-round-group">
                          <div class="match-round">{{ getRoundLabel(match.round, match.meta) }}</div>
                          <div v-if="shouldShowCompetitionName(match)" class="match-competition text-gray">{{ get(match, 'competition.name', 'TBD') }}</div>
                        </div>

                        <div class="team-info home mr-20">
                          <div class="team-name">{{ get(match.homeTeam, 'name', 'TBD') }}</div>
                          <TeamLogo :team="match.homeTeam" class="team-logo" v-if="!matchIsVs(match)" />
                          <TeamLogoVs :team="match.homeTeam" class="team-logo" v-else />
                        </div>

                        <div class="match-status">
                          <div class="score-text">
                            {{ getScore('homeTeam', match.scoringEvents, match.scores, match.status, match.meta, match.homeTeam, match.competition._id) }} -
                            {{ getScore('awayTeam', match.scoringEvents, match.scores, match.status, match.meta, match.awayTeam, match.competition._id) }}
                          </div>

                          <ion-badge :color="gameStatusColor(match.status)" :class="gameStatusClass(match.status)">
                            <div v-if="gameStatusProgress(match.status)" class="dot"></div>
                            <p>{{ upperCase(match.status).replace('FIRST', '1st').replace('SECOND', '2nd').replace('THIRD', '3rd').replace('FOURTH', '4th') }}</p>
                          </ion-badge>

                          <div class="match-referees" v-if="hasReferees(match)">
                            <div>Referees:</div>
                            <div class="text-gray" v-for="referee in refereesToShow(match)" :key="get(referee, '_id')">
                              <span>{{ get(referee, 'firstName', '') }} {{ get(referee, 'lastName', '') }}</span>
                            </div>
                          </div>
                        </div>

                        <div class="team-info away ml-20">
                          <TeamLogo :team="match.awayTeam" class="team-logo" v-if="!matchIsVs(match)" />
                          <TeamLogoVs :team="match.awayTeam" class="team-logo" v-else />
                          <div class="team-name">{{ get(match.awayTeam, 'name', 'TBD') }}</div>
                        </div>

                        <div class="match-venue ml-10 flex flex-column">
                          <span class="match-venue-name">{{ get(match.venue, 'name', 'N/A') }}</span>
                          <span class="match-venue-field text-gray">{{ fieldDisplayName(get(match, 'meta.field')) }}</span>
                        </div>
                      </div>

                      <!-- Mobile layout (same as your other block) -->
                      <div class="match-row-mobile">
                        <div class="teams-status">
                          <div class="team-info home">
                            <TeamLogo :team="match.homeTeam" class="team-logo" />
                            <div class="team-name">{{ get(match.homeTeam, 'name', 'TBD') }}</div>
                          </div>

                          <div class="match-status">
                            <div class="score-text">
                              {{ getScore('homeTeam', match.scoringEvents, match.scores, match.status, match.meta, match.homeTeam, match.competition._id) }} -
                              {{ getScore('awayTeam', match.scoringEvents, match.scores, match.status, match.meta, match.awayTeam, match.competition._id) }}
                            </div>

                            <ion-badge :color="gameStatusColor(match.status)" :class="gameStatusClass(match.status)">
                              <div v-if="gameStatusProgress(match.status)" class="dot"></div>
                              <p>{{ upperCase(match.status).replace('FIRST', '1st').replace('SECOND', '2nd').replace('THIRD', '3rd').replace('FOURTH', '4th') }}</p>
                            </ion-badge>

                            <div class="match-referees" v-if="hasReferees(match)">
                              <div>Referees:</div>
                              <div v-for="referee in refereesToShow(match)" :key="get(referee, '_id')">
                                <span>{{ get(referee, 'firstName', '') }} {{ get(referee, 'lastName', '') }}</span>
                              </div>
                            </div>
                          </div>

                          <div class="team-info away">
                            <TeamLogo :team="match.awayTeam" class="team-logo" />
                            <div class="team-name">{{ get(match.awayTeam, 'name', 'TBD') }}</div>
                          </div>
                        </div>

                        <div class="match-details">
                          <div class="match-time">{{ moment(match.dateTime).format('HH:mm') }}</div>
                          <div class="match-round">{{ getRoundLabel(match.round, match.meta) }}</div>
                        </div>
                        <div v-if="shouldShowCompetitionName(match)" class="match-competition text-gray">{{ get(match, 'competition.name', 'TBD') }}</div>
                        <div class="match-venue">{{ get(match.venue, 'name', 'N/A') }}</div>
                        <div class="match-field text-gray">{{ fieldDisplayName(get(match, 'meta.field')) }}</div>
                      </div>
                    </ion-card-content>
                  </ion-card>
                  <!-- BYE card for matches marked as bye -->
                  <ion-card v-else class="custom-card bye">
                    <ion-card-content>
                      <ion-text><h4 class="round-text bye-text f-bold">BYES</h4></ion-text>
                      <div class="bye-teams-container">
                        <div v-if="match.homeTeam && match.homeTeam._id" class="bye-team clickable" @click="handleByeTeamClick(match)">
                          <TeamLogo :team="match.homeTeam" />
                          <div class="team-name light-text text-center mt-10">{{ get(match.homeTeam, 'name', 'Unknown Team') }}</div>
                          <ion-badge v-if="match.status === 'final'" :color="gameStatusColor(match.status)" class="bye-status-badge mt-5">
                            {{ upperCase(match.status) }}
                          </ion-badge>
                        </div>
                        <div v-else-if="match.awayTeam && match.awayTeam._id" class="bye-team clickable" @click="handleByeTeamClick(match)">
                          <TeamLogo :team="match.awayTeam" />
                          <div class="team-name light-text text-center mt-10">{{ get(match.awayTeam, 'name', 'Unknown Team') }}</div>
                          <ion-badge v-if="match.status === 'final'" :color="gameStatusColor(match.status)" class="bye-status-badge mt-5">
                            {{ upperCase(match.status) }}
                          </ion-badge>
                        </div>
                      </div>
                    </ion-card-content>
                  </ion-card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="['time', 'venue', 'field'].includes(activeMatchesView)">
        <div
          v-for="(group, groupIndex) in groupedMatchesBySelectedView"
          :key="`${activeMatchesView}-${group.key}-${groupIndex}-${key}`"
          class="mb-2"
        >
          <div class="competition-group">
            <div class="competition-header" @click="toggleSimpleGroup(group.key)">
              <div class="competition-title">
                <h3>{{ group.label }}</h3>
                <ion-icon :icon="getSimpleGroupOpenState(group.key) ? chevronUp : chevronDown" />
              </div>
            </div>
            <div v-if="getSimpleGroupOpenState(group.key)">
              <ion-card
                v-for="match in group.matches"
                :key="match._id"
                class="custom-card"
                @click="goMatch(match._id, match.homeTeam, match.awayTeam, match.meta, match.competition, match.competitionSettings)"
              >
                <ion-card-content v-if="!match.meta.isBye">
                  <div class="match-row">
                    <div class="match-time ml-10">{{ moment(match.dateTime).format('HH:mm') }}</div>
                    <div class="match-round-group">
                      <div class="match-round">{{ getRoundLabel(match.round, match.meta) }}</div>
                      <div v-if="shouldShowCompetitionName(match)" class="match-competition text-gray">{{ get(match, 'competition.name', 'TBD') }}</div>
                    </div>
                    <div class="team-info home mr-20">
                      <div class="team-name">{{ get(match.homeTeam, 'name', 'TBD') }}</div>
                      <TeamLogo :team="match.homeTeam" class="team-logo" v-if="!matchIsVs(match)" />
                      <TeamLogoVs :team="match.homeTeam" class="team-logo" v-else />
                    </div>
                    <div class="match-status">
                      <div class="score-text">
                        {{ getScore('homeTeam', match.scoringEvents, match.scores, match.status, match.meta, match.homeTeam, match.competition._id) }} -
                        {{ getScore('awayTeam', match.scoringEvents, match.scores, match.status, match.meta, match.awayTeam, match.competition._id) }}
                      </div>
                      <ion-badge :color="gameStatusColor(match.status)" :class="gameStatusClass(match.status)">
                        <div v-if="gameStatusProgress(match.status)" class="dot"></div>
                        <p>{{ upperCase(match.status).replace('FIRST', '1st').replace('SECOND', '2nd').replace('THIRD', '3rd').replace('FOURTH', '4th') }}</p>
                      </ion-badge>
                      <div class="match-referees" v-if="hasReferees(match)">
                        <div>Referees:</div>
                        <div class="text-gray" v-for="referee in refereesToShow(match)" :key="get(referee, '_id')">
                          <span>{{ get(referee, 'firstName', '') }} {{ get(referee, 'lastName', '') }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="team-info away ml-20">
                      <TeamLogo :team="match.awayTeam" class="team-logo" v-if="!matchIsVs(match)" />
                      <TeamLogoVs :team="match.awayTeam" class="team-logo" v-else />
                      <div class="team-name">{{ get(match.awayTeam, 'name', 'TBD') }}</div>
                    </div>
                    <div class="match-venue ml-10 flex flex-column">
                      <span class="match-venue-name">{{ get(match.venue, 'name', 'N/A') }}</span>
                      <span class="match-venue-field text-gray">{{ fieldDisplayName(get(match, 'meta.field')) }}</span>
                    </div>
                  </div>

                  <div class="match-row-mobile">
                    <div class="teams-status">
                      <div class="team-info home">
                        <TeamLogo :team="match.homeTeam" class="team-logo" />
                        <div class="team-name">{{ get(match.homeTeam, 'name', 'TBD') }}</div>
                      </div>
                      <div class="match-status">
                        <div class="score-text">
                          {{ getScore('homeTeam', match.scoringEvents, match.scores, match.status, match.meta, match.homeTeam, match.competition._id) }} -
                          {{ getScore('awayTeam', match.scoringEvents, match.scores, match.status, match.meta, match.awayTeam, match.competition._id) }}
                        </div>
                        <ion-badge :color="gameStatusColor(match.status)" :class="gameStatusClass(match.status)">
                          <div v-if="gameStatusProgress(match.status)" class="dot"></div>
                          <p>{{ upperCase(match.status).replace('FIRST', '1st').replace('SECOND', '2nd').replace('THIRD', '3rd').replace('FOURTH', '4th') }}</p>
                        </ion-badge>
                        <div class="match-referees" v-if="hasReferees(match)">
                          <div>Referees:</div>
                          <div v-for="referee in refereesToShow(match)" :key="get(referee, '_id')">
                            <span>{{ get(referee, 'firstName', '') }} {{ get(referee, 'lastName', '') }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="team-info away">
                        <TeamLogo :team="match.awayTeam" class="team-logo" />
                        <div class="team-name">{{ get(match.awayTeam, 'name', 'TBD') }}</div>
                      </div>
                    </div>
                    <div class="match-details">
                      <div class="match-time">{{ moment(match.dateTime).format('HH:mm') }}</div>
                      <div class="match-round">{{ getRoundLabel(match.round, match.meta) }}</div>
                    </div>
                    <div v-if="shouldShowCompetitionName(match)" class="match-competition text-gray">{{ get(match, 'competition.name', 'TBD') }}</div>
                    <div class="match-venue">{{ get(match.venue, 'name', 'N/A') }}</div>
                    <div class="match-field text-gray">{{ fieldDisplayName(get(match, 'meta.field')) }}</div>
                  </div>
                </ion-card-content>
              </ion-card>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-column align-center" v-if="!loading && !groupedMatches.length">
        <ion-text class="text-center mt-30">No matches found for this time period, please try adjusting your filters.</ion-text>
      </div>
      <ion-item v-if="matchesLoadError">
        <ion-label>Unable to load matches. Please try again.</ion-label>
        <ion-button :disabled="processMatchesFlag || isLoadingMore" @click="page === 0 ? processMatches('retry') : loadMatches()">Retry</ion-button>
      </ion-item>
      <ion-infinite-scroll
        @ionInfinite="loadData($event)"
        threshold="100px"
        id="infinite-scroll"
        :disabled="isDisabled"
      >
        <ion-infinite-scroll-content
          loading-spinner="bubbles"
          loading-text="Loading more matches...">
        </ion-infinite-scroll-content>
      </ion-infinite-scroll>
    </ion-content>
  </ion-page>
</template>

<script>
import { IonChip, IonDatetimeButton } from "@ionic/vue";
import { reactive } from 'vue';

import {
  closeOutline,
  ellipsisVertical,
  alertCircleOutline,
  informationCircleOutline,
  personCircleOutline,
  arrowForwardOutline,
  arrowBackOutline,
  chevronBackCircleOutline,
  settingsOutline,
  closeCircle,
  chevronUp,
  chevronDown,
} from "ionicons/icons";
import {
  IonDatetime,
  ionIcon,
  IonModal,
  IonInfiniteScroll,
  modalController,
  loadingController,
  alertController,
  IonInfiniteScrollContent,
  InfiniteScrollCustomEvent
} from "@ionic/vue";
import { eventBus } from '@/eventBus'
import { getRoleName, roles } from '@/utils/roles';
import TeamLogo from './base/team-logo.vue';
import matchesLoading from './mixins/matches-loading';
import TeamLogoVs from './base/team-logo-vs.vue';
import CompetitionFilter from "./components/competition-filter";
import moment from 'moment-timezone';
import _ from 'lodash';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'


export default {
  mixins: [matchesLoading],
  components: {
    TeamLogo,
    TeamLogoVs,
    IonDatetime,
    IonDatetimeButton,
    IonModal,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    InfiniteScrollCustomEvent,
    VueDatePicker,
    IonChip,
  },
  data() {
    const matchesCompetitions = this.$store.getters['page/matchesCompetition'];
    const matchesRound = this.$store.getters['page/matchesRound'];
    const { filter } = this.$store.state.matches;
    const startDate = new Date();
    const endDate = new Date(new Date().setDate(startDate.getDate() + 7));
    return {
      datePickerData: [undefined, undefined],
      isDisabled: false,
      timerHasRan: false,
      closeOutline,
      pickedDate: null,
      page: 1,
      totalMatches: 0,
      chevronBackCircleOutline,
      upperCase: _.upperCase,
      alertCircleOutline,
      informationCircleOutline,
      orderInfoOpen: false,
      orderInfoEvent: undefined,
      get: _.get,
      ellipsisVertical,
      personCircleOutline,
      arrowForwardOutline,
      closeCircle,
      arrowBackOutline,
      settingsOutline,
      chevronDown,
      chevronUp,
      competitions: [],
      competitionsWithMatches: [],
      filterSeason: undefined,
      competitionIds: matchesCompetitions ? matchesCompetitions : filter.competitionIds,
      round: matchesRound ? matchesRound : filter.round,
      rounds: [],
      matches: [],
      filter,
      key: 0,
      checkedCompetitionFilter: [],
      loaded: false,
      availableDays: [],
      customAlertOptions: {
        header: 'Select competitions',
        translucent: true,
        cssClass: 'my-custom-alert'
      },
      customAlertOptionsSeason: {
        header: 'Select season',
        translucent: true,
      },
      competitionBeingSet: false,
      roundComplete: false,
      getMatchesCount: 1,
      getCompetitionsCount: 1,
      loadingMatchesCompIds: 1,
      loadingMatchesFilterSeason: 1,
      initialLoad: true,
      nationalId: +process.env.VUE_APP_NATIONAL_ID,
      filterListShow: false,
      processMatchesFlag: false,
      activeDateFilter: 'next7days',
      selectedDate: null,
      competitionOpenState: {},
      gameTypes: [
        { type: 'teams', name: 'Teams' },
        { type: 'indv', name: 'Individual' },
      ],
      gameType: 'all',
      activeMatchesView: 'competition',
      simpleGroupOpenState: {},
      competitionGroupOpenState: {},
    };
  },
  async mounted() {
    eventBus.on('matchStatusUpdated', this.updateMatchInList);
    await this.$store.dispatch('settings/setup');
    const matchSettings = _.get(this.$store.getters['settings/settings'], 'matchSettings', {});
    this.activeMatchesView = _.get(matchSettings, 'groupMatchesBy', 'competition');

    // Load default season from API, fallback to current season, then latest season
    try {
      const response = await this.$http.get('/assemble/api/v1/manager/presentation-settings');
      if (response.data.status === 'success') {
        const defaultSeason = _.get(response.data.data, 'presentationSettings.defaultSeason', null);
        if (defaultSeason) {
          this.filterSeason = defaultSeason;
        }
      }
    } catch (error) {
      console.error('Error loading default season:', error);
    }

    // Fallback logic if no default season set
    if (!this.filterSeason && this.seasons && this.seasons.length > 0) {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      if (+process.env.VUE_APP_NATIONAL_ID === 17) {
        this.filterSeason = 2024;
      } else {
        const currentSeason = this.seasons.find(season => season.currentSeason);
        const latestSeason = _.maxBy(this.seasons, season => +_.get(season, '_id'));
        this.filterSeason = currentSeason?._id || latestSeason?._id;
      }
    }

    this.updateDateFilter();
    let reqPromises = [];
    const getCompPromise = this.getCompetitions();
    // const processMatchPromise = this.processMatches('mounted');
    const handlerFilterChangePromise = this.filterRequest();
    reqPromises = [getCompPromise, handlerFilterChangePromise];
    await Promise.all(reqPromises);
  },
  beforeUnmount() {
    eventBus.off('matchStatusUpdated', this.updateMatchInList);
  },
  computed: {
    groupedMatches() {
      const grouped = _.groupBy(this.filteredCompetitionsWithMatches, match => moment(match.dateTime).format('YYYY-MM-DD'));
      // const returnData = Object.entries(grouped).map(([date, matches]) => ({
      //   date,
      //   competitions: _.orderBy(Object.entries(_.groupBy(matches, match => _.get(match, 'competition.name', 'TBD')))
      //     .map(([name, competitionMatches]) => ({
      //       name,
      //       matches: competitionMatches.filter(match => match.meta && !match.meta.isBye),
      //       byeTeams: competitionMatches
      //         .filter(match => match.meta && match.meta.isBye)
      //         .map(match => match.homeTeam && match.homeTeam._id ? match.homeTeam : match.awayTeam)
      //         .filter(team => team && team._id),
      //       isOpen: this.getCompetitionOpenState(date, name),
      //       order: _.get(competitionMatches, '.competition.order', 0),
      //     })), ['order', '_id'], ['asc', 'asc']),
      // }));

      const returnData = Object.entries(grouped).map(([date, matches]) => {
        const competitions = Object.entries(_.groupBy(matches, match =>
          _.get(match, 'competition.name', 'TBD')
        )).map(([name, competitionMatches]) => {
          // Find first valid order if it exists
          const firstWithOrder = competitionMatches.find(m => _.get(m, 'competition.order') !== undefined);
          const order = _.get(firstWithOrder, 'competition.order', null);

          return {
            name,
            matches: competitionMatches.filter(match => match.meta && !match.meta.isBye),
            byeMatches: competitionMatches
              .filter(match => match.meta && match.meta.isBye)
              .map(match => ({
                team: match.homeTeam && match.homeTeam._id ? match.homeTeam : match.awayTeam,
                match: match
              }))
              .filter(item => item.team && item.team._id),
            isOpen: this.getCompetitionOpenState(date, name),
            order,
          };
        });

        // Sort by `order` if present, otherwise by name using natural sort
        const sortedCompetitions = competitions.sort((a, b) => {
          if (a.order != null && b.order != null) {
            return a.order - b.order;
          } else if (a.order != null) {
            return -1;
          } else if (b.order != null) {
            return 1;
          } else {
            // Natural sort fallback by name
            return a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' });
          }
        });

        return {
          date,
          competitions: sortedCompetitions,
        };
      });
      return returnData;
    },
    groupedMatchesByCompetitions() {
      const grouped = _.groupBy(this.filteredCompetitionsWithMatches, match => _.get(match, 'competition.name', 'TBD'));
      const returnData = Object.entries(grouped).map(([competitionName, matches]) => ({
        competitionName,
        days: _.orderBy(Object.entries(_.groupBy(matches, match => moment(match.dateTime).format('YYYY-MM-DD')))
          .map(([date, dateMatches]) => ({
            date,
            matches: dateMatches,
          })), ['date'], ['asc']),
      }));
      return returnData;
    },
    groupedMatchesBySelectedView() {
      if (!['time', 'venue', 'field'].includes(this.activeMatchesView)) {
        return [];
      }

      return Object.entries(_.groupBy(this.filteredCompetitionsWithMatches, match => this.getSimpleGroupKey(match)))
        .map(([key, matches]) => {
          const visibleMatches = matches.filter(match => match.meta && !match.meta.isBye);
          if (!visibleMatches.length) {
            return null;
          }

          return {
            key,
            label: this.getSimpleGroupLabel(visibleMatches[0]),
            sortValue: this.getSimpleGroupSortValue(visibleMatches[0]),
            matches: this.sortMatchesForGroup(visibleMatches),
          };
        })
        .filter(Boolean)
        .sort((a, b) => this.compareSimpleGroups(a, b));
    },
    sortedCompetition() {
      // const comp = _.cloneDeep(this.competitions);
      // return comp.sort((a, b) => a.order > b.order ? 1 : -1);
      // return _.sortBy(comp, 'order');
      // order is the user's drag-and-drop sort from Settings > Competition Sort; name breaks ties alphabetically
      return _.orderBy(
        this.competitions,
        ['order', (c) => (c.name || '').toLowerCase(), '_id'],
        ['asc', 'asc', 'asc']
      );
      // return this.competitions;
    },
    timezone() {
      return this.$store.getters['national/timezone'];
    },
    filteredCompetitionsWithMatches() {
      return this.competitionsWithMatches;
    },
    bannerTitle() {
      return process.env.VUE_APP_BANNER_TITLE;
    },
    seasons(){
      // The API returns seasons unsorted; show them in order (ASWL-2002)
      return _.sortBy(this.$store.state.national.seasons || [], season => +_.get(season, '_id'));
    },
    nationalAppLogo() {
      return process.env.VUE_APP_LOGO || require('@/assets/logo/assemble_positive.png');
    },
    placeholder() {
      return process.env.VUE_APP_PLACEHOLDER || require('@/assets/images/club-placeholder.png');
    },
    logo() {
      const logo = process.env.VUE_APP_LOGO && process.env.VUE_APP_LOGO !== '' ? process.env.VUE_APP_LOGO : require('@/assets/images/club-placeholder.png');
      const logoMark = process.env.VUE_APP_LOGO_MARK && process.env.VUE_APP_LOGO_MARK !== '' ? process.env.VUE_APP_LOGO_MARK : require('@/assets/images/club-placeholder.png');
      return logo || logoMark;
    },
  },
  methods: {
    fieldDisplayName(field) {
      if (!field || !field.name) return '';
      if (!field.surface || field.surface === 'N/A') return field.name;
      return `${field.name} (${field.surface})`;
    },
    openOrderInfo(ev) {
      this.orderInfoEvent = ev;
      this.orderInfoOpen = true;
    },
    async persistMatchesViewSetting(view) {
      const settings = _.cloneDeep(this.$store.getters['settings/settings'] || {});
      _.set(settings, 'matchSettings.groupMatchesBy', view);
      if (_.get(settings, 'matchSettings.skipTimeCapture') === undefined) {
        _.set(settings, 'matchSettings.skipTimeCapture', false);
      }
      await this.$store.dispatch('settings/updateSettings', { settings });
    },
    toggleCompetitionGroup(competitionName) {
      this.competitionGroupOpenState[competitionName] = !this.getCompetitionGroupOpenState(competitionName);
      this.key++;
    },
    getCompetitionGroupOpenState(competitionName) {
      return this.competitionGroupOpenState[competitionName] !== false; // Default to open
    },
    async setMatchesView(view) {
      this.activeMatchesView = view;
      await this.persistMatchesViewSetting(view);
    },
    shouldShowCompetitionName() {
      return ['time', 'field', 'venue'].includes(this.activeMatchesView);
    },
    toggleSimpleGroup(groupKey) {
      this.simpleGroupOpenState[groupKey] = !this.getSimpleGroupOpenState(groupKey);
      this.key++;
    },
    getSimpleGroupOpenState(groupKey) {
      return this.simpleGroupOpenState[groupKey] !== false;
    },
    getSimpleGroupKey(match) {
      if (this.activeMatchesView === 'time') {
        return moment(match.dateTime).tz(this.timezone).format('YYYY-MM-DD HH:mm');
      }

      if (this.activeMatchesView === 'venue') {
        return _.get(match, 'venue.name', 'Unknown Venue');
      }

      const fieldName = _.get(match, 'meta.field.name', 'Unassigned Field');
      const venueName = _.get(match, 'venue.name', 'Unknown Venue');
      return `${fieldName}|||${venueName}`;
    },
    getSimpleGroupLabel(match) {
      if (!match) return '';

      if (this.activeMatchesView === 'time') {
        const [startDate, endDate] = this.datePickerData || [];
        const hasSingleDayRange = startDate && endDate
          && moment(startDate).tz(this.timezone).format('YYYY-MM-DD') === moment(endDate).tz(this.timezone).format('YYYY-MM-DD');
        return hasSingleDayRange
          ? moment(match.dateTime).tz(this.timezone).format('HH:mm')
          : moment(match.dateTime).tz(this.timezone).format('ddd, MMM DD YYYY - HH:mm');
      }

      if (this.activeMatchesView === 'venue') {
        return this.formatVenueGroupLabel(match);
      }

      return this.formatFieldGroupLabel(match);
    },
    getSimpleGroupSortValue(match) {
      if (!match) return '';

      if (this.activeMatchesView === 'time') {
        return moment(match.dateTime).tz(this.timezone).valueOf();
      }

      if (this.activeMatchesView === 'venue') {
        return _.get(match, 'venue.name', '').toLowerCase();
      }

      return `${_.get(match, 'meta.field.name', '').toLowerCase()}|||${_.get(match, 'venue.name', '').toLowerCase()}`;
    },
    compareSimpleGroups(a, b) {
      if (this.activeMatchesView === 'time') {
        return a.sortValue - b.sortValue;
      }

      return String(a.sortValue).localeCompare(String(b.sortValue), undefined, { numeric: true, sensitivity: 'base' });
    },
    sortMatchesForGroup(matches) {
      return _.orderBy(
        matches,
        [
          (match) => moment(match.dateTime).tz(this.timezone).valueOf(),
          (match) => _.get(match, 'meta.field.name', ''),
          (match) => _.get(match, 'venue.name', ''),
          (match) => _.get(match, 'competition.order', Number.MAX_SAFE_INTEGER),
          (match) => _.get(match, 'competition.name', ''),
        ],
        ['asc', 'asc', 'asc', 'asc', 'asc']
      );
    },
    formatVenueGroupLabel(match) {
      const venueName = _.get(match, 'venue.name');
      return venueName && `${venueName}`.trim().length ? venueName : 'Venue: Not set';
    },
    formatFieldGroupLabel(match) {
      const fieldName = _.get(match, 'meta.field.name');
      const venueName = _.get(match, 'venue.name');
      const fieldLabel = fieldName && `${fieldName}`.trim().length ? fieldName : 'Field: Not set';
      const venueLabel = venueName && `${venueName}`.trim().length ? venueName : 'Venue: Not set';
      return `${fieldLabel} - ${venueLabel}`;
    },
    matchIsVs(match) {
      return _.get(match, 'competitionSettings.type') === 'vs';
    },
    async filterRequest() {
      try {
        const res = await this.$http.get("assemble/api/v1/manager/competitions/filterlist");
        const userRoles = res.data.data;
        const activeRole = this.$store.getters['user/activeRole'];
        const filteredRoles = _.filter(userRoles, (ur) => {
          const ownRole = activeRole._id === ur._id;
          let isIncluded = false;
          if (activeRole.type === roles.competitionAdmin) {
            // include all comp-admin roles owned by this user
            isIncluded = ur.type === roles.competitionAdmin;
          } else if (_.get(ur, 'entity.orgtree', null)) {
            if (activeRole.type === roles.superAdmin) {
              isIncluded = activeRole.entity._id === _.get(ur, 'entity.orgtree.national._id', null);
            } else if (activeRole.type === roles.stateAdmin) {
              isIncluded = activeRole.entity._id === _.get(ur, 'entity.orgtree.state._id', null);
            } else if (activeRole.type === roles.associationAdmin) {
              isIncluded = activeRole.entity._id === _.get(ur, 'entity.orgtree.association._id', null);
            } else if (activeRole.type === roles.clubAdmin) {
              isIncluded = activeRole.entity._id === _.get(ur, 'entity.orgtree.club._id', null);
            }
          }
          return ownRole || isIncluded;
        });
        // dedupe by competition entity._id
        const seenEntityIds = new Set();
        const dedupedRoles = _.filter(filteredRoles, (ur) => {
          const entityId = _.get(ur, 'entity._id');
          if (!entityId || seenEntityIds.has(String(entityId))) return false;
          seenEntityIds.add(String(entityId));
          return true;
        });
        dedupedRoles.forEach((userRole) => {
          userRole.checked = true;
          this.checkedCompetitionFilter.push(userRole);
        });
        this.initialLoad = false;
      } catch (error) {
        console.log(error);
      }
    },
    hasReferees(match) {
      const referees = _.get(match, 'referees', []);
      const mapRefereesWithMemberIds = _.compact(_.map(referees, 'memberId'));
      return !_.isEmpty(mapRefereesWithMemberIds);
    },
    refereesToShow(match) {
      // Only referees actually saved (have a memberId), capped at the first 2 — mirrors match.vue detail
      return _.get(match, 'referees', []).filter(referee => _.get(referee, 'memberId')).slice(0, 2);
    },
    clearAllFilters() {
      this.selectedDate = null;
      this.activeDateFilter = null;
      this.competitionIds = null;
      this.round = undefined;
      this.updateDateFilter();
      this.handleFilterChange('clear-all-filters');
    },
    updateMatchInList({ matchId, newStatus }) {
      if (newStatus === 'resolve') {
        newStatus = 'final'
      }
      console.log('this.competitionsWithMatches before update:', this.competitionsWithMatches);

      this.competitionsWithMatches = this.competitionsWithMatches.map(match => {
        if (match._id === matchId) {
          return { ...match, status: newStatus };
        }
        return match;
      });

      console.log('this.competitionsWithMatches after update:', this.competitionsWithMatches);
    },
    toggleCompetition(dayIndex, compIndex) {
      const date = this.groupedMatches[dayIndex].date;
      const competitionName = this.groupedMatches[dayIndex].competitions[compIndex].name;
      const currentState = this.getCompetitionOpenState(date, competitionName);

      this.competitionOpenState[`${date}-${competitionName}`] = !currentState;
      this.key++;
    },
    getCompetitionOpenState(date, competitionName) {
      const key = `${date}-${competitionName}`;
      return this.competitionOpenState[key] !== false; // Default to true if not set
    },
    setDateFilter(filter) {
      this.activeDateFilter = filter;
      this.selectedDate = null;
      this.updateDateFilter();
    },
    openDatePicker() {
      this.$refs.datePicker.openMenu();
    },
    onDateSelect() {
      this.activeDateFilter = null;
      // Ensure the selected date is in the correct timezone
      this.selectedDate = this.moment(this.selectedDate).tz(this.timezone).toDate();
      this.updateDateFilter();
    },
    clearDateSelect() {
      this.selectedDate = null;
      this.activeDateFilter = null;
      this.updateDateFilter();
    },
    formatSelectedDate() {
      return moment(this.selectedDate).tz(this.timezone).format('MMM D, YYYY');
    },
    updateDateFilter() {
      console.log('Updating Date Filter');
      let startDate, endDate;
      const sydneyTz = 'Australia/Sydney';
      const today = moment().tz(sydneyTz).startOf('day');
      const nextWeek = moment().tz(sydneyTz).add(7, 'days').startOf('day');
      const nextMonth = moment().tz(sydneyTz).add(1, 'month').startOf('day');

      switch (this.activeDateFilter) {
      case 'yesterday':
        startDate = today.clone().subtract(1, 'day');
        endDate = today.clone().subtract(1, 'day').endOf('day');
        break;
      case 'today':
        startDate = today.clone();
        endDate = today.clone().endOf('day');
        break;
      case 'tomorrow':
        startDate = today.clone().add(1, 'day').startOf('day');
        endDate = today.clone().add(1, 'day').endOf('day');
        break;
      case 'next7days':
        startDate = today.clone();
        endDate = nextWeek.clone().endOf('day');
        break;
      case 'nextMonth':
        startDate = today.clone();
        endDate = nextMonth.clone().endOf('day');
        break;
      default:
        if (this.selectedDate) {
          startDate = moment(this.selectedDate).tz(sydneyTz).startOf('day');
          endDate = moment(this.selectedDate).tz(sydneyTz).endOf('day');
        } else {
          startDate = undefined;
          endDate = undefined;
        }
      }

      this.datePickerData = [
        startDate ? startDate.toDate() : undefined,
        endDate ? endDate.toDate() : undefined
      ];
      console.log('Updated Date Filter - Going to Filter Change');
      this.handleFilterChange('date-filter');
    },
    assignCompetitionIds(event) {
      console.log({
        event,
        targetValue: event.target.value,
      });
      this.competitionIds = event.target.value;
    },
    async downloadMemberList(teamId) {
      if (pdfMake.vfs === undefined) pdfMake.vfs = pdfFonts.pdfMake.vfs;
      const homeDD = await this.$http.get(`/assemble/api/v1/manager/teams/${teamId}/member-list-pdf`);
      // homeDD.data.data.content.unshift('\n');
      // homeDD.data.data.content.unshift({ image: 'logo', width: [100], alignment: 'center' });
      // homeDD.data.data.images = { logo: await this.getBase64Logo() };
      return pdfMake.createPdf(homeDD.data.data).download(`${teamId}-member-list.pdf`);
    },
    getBase64Logo() {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.setAttribute('crossOrigin', 'anonymous');
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          const dataURL = canvas.toDataURL('image/png');
          resolve(dataURL);
        };
        img.onerror = (error) => {
          reject(error);
        };
        img.src = `${ this.logo }?r=${ Math.floor(Math.random() * 100000)}`;
      });
    },
    toggleFilterList(){
      this.filterListShow = !this.filterListShow;
    },
    getByes(round) {
      console.log('round', round);

    },
    async getCompetitions() {
      const loading = await loadingController.create({ message: "Loading competitions..." })
      try {
        loading.present();
        console.log(`Get Competitions [Get Competitions] ${this.getCompetitionsCount}`);
        this.getCompetitionsCount++;
        const activeRole = this.$store.getters['user/activeRole'];
        const checkedRoles = _.filter(this.checkedCompetitionFilter, c => c.checked === true);
        const res = await this.$http.post("assemble/api/v1/manager/competitions", {
          roles: checkedRoles.length ? checkedRoles : [activeRole],
          season: this.filterSeason,
          gameType: this.gameType,
        });
        this.competitions = res.data.data;
        if (this.competitions.length && !this.filter.competitionId) {
          // this.$store.commit('matches/setCompetitionIds', this.competitions[0]._id);
          this.$store.commit('matches/setLaddertemplate', this.competitions[0].laddertemplate);
          // this.filter.competitionId = this.competitions[0]._id;
          // this.competitionId = this.competitions[0]._id;
          this.key++;
        }
      } catch (error) {
        console.log(error);
      } finally {
        loading.dismiss();
      }
    },
    async getMatches(where, page = this.page) {
      let nextRound;
      if (this.roundComplete) {
        const index = Object.values(this.rounds).indexOf(this.round);
        nextRound = this.rounds[index + 1];
      }
      // Capture filters before creating the asynchronous loading overlay.
      const filters = _.cloneDeep({
        competitionIds: this.competitionIds,
        round: this.round,
        nextRound,
        date: this.datePickerData,
        season: this.filterSeason,
        gameType: this.gameType,
      });
      const loading = await loadingController.create({ message: 'Loading matches...' });
      try {
        await loading.present();
        return await this.$http.post(
          `assemble/api/v1/manager/matches/data-table/20/${page}`, filters
        );
      } finally {
        await loading.dismiss();
      }
    },
    async processMatches(where, isNotRound = true) {
      await this.loadMatches({ reset: true, updateRounds: isNotRound, where });
    },
    async handleSeasonChange() {
      // ASWL-2002: start the new season with a clean filter. Competitions and rounds belong to the
      // previous season; the date filter goes back to the default (Next 7 Days).
      this.competitionIds = null;
      this.$store.commit('matches/setCompetitionIds', null);
      this.round = undefined;
      this.activeDateFilter = 'next7days';
      this.selectedDate = null;
      await this.getCompetitions();
      // Sets the Next 7 Days range and reloads matches, refreshing the round list and available days
      this.updateDateFilter();
    },
    async handleGameTypeChange() {
      await this.getCompetitions();
      // await this.processMatches('handleGameTypeChange', false);
      await this.handleFilterChange('ion gameType round');
    },
    async handleFilterChange(where, event = null) {
      console.log('Filter Change', where);
      if (where === 'ion select competition' && event) {
        const value = event.detail.value;
        this.competitionIds = !value || value.length === 0
          ? null
          : (Array.isArray(value) ? value : value.split(',').map(Number));
        this.$store.commit('matches/setCompetitionIds', this.competitionIds);
      }

      if (where !== 'ion select round') {
        await this.processMatches('handleFilterChange');
      } else {
        await this.processMatches('handleFilterChange', false);
      }

      // if (this.initialLoad) {
      //   try {
      //     const res = await this.$http.get("assemble/api/v1/manager/competitions/filterlist");
      //     const userRoles = res.data.data;
      //     const activeRole = this.$store.getters['user/activeRole'];
      //     const filteredRoles = _.filter(userRoles, (ur) => {
      //       const ownRole = activeRole._id === ur._id;
      //       let isIncluded = false;
      //       if (_.get(ur, 'entity.orgtree', null)) {
      //         if (activeRole.type === roles.superAdmin) {
      //           isIncluded = activeRole.entity._id === _.get(ur, 'entity.orgtree.national._id', null);
      //         } else if (activeRole.type === roles.stateAdmin) {
      //           isIncluded = activeRole.entity._id === _.get(ur, 'entity.orgtree.state._id', null);
      //         } else if (activeRole.type === roles.associationAdmin) {
      //           isIncluded = activeRole.entity._id === _.get(ur, 'entity.orgtree.association._id', null);
      //         } else if (activeRole.type === roles.clubAdmin) {
      //           isIncluded = activeRole.entity._id === _.get(ur, 'entity.orgtree.club._id', null);
      //         }
      //       }
      //       return ownRole || isIncluded;
      //     });
      //     filteredRoles.forEach((userRole) => {
      //       userRole.checked = true;
      //       this.checkedCompetitionFilter.push(userRole);
      //     });
      //     this.initialLoad = false;
      //   } catch (error) {
      //     console.log(error);
      //   }
      // }
    },
    checkItem(_id) {
      const itemToCheck = _.find(this.checkedCompetitionFilter, ccf => ccf._id === _id);
      if (itemToCheck) itemToCheck.checked = true;
    },
    uncheckItem(_id) {
      const itemToCheck = _.find(this.checkedCompetitionFilter, ccf => ccf._id === _id);
      if (itemToCheck) itemToCheck.checked = false;
    },
    checkAll() {
      this.checkedCompetitionFilter.forEach((item, i) => {
        this.checkedCompetitionFilter[i].checked = true;
      });
    },
    deselectAll() {
      this.checkedCompetitionFilter.forEach((item, i) => {
        this.checkedCompetitionFilter[i].checked = false;
      });
    },
    onFilter() {
      modalController
        .create({
          component: CompetitionFilter,
          cssClass: "custom-modal",
          componentProps: {
            close: () => this.modal.dismiss(),
            checkedCompetitionFilter: this.checkedCompetitionFilter,
            selectAll: this.checkAll,
            deselectAll: this.deselectAll,
            refreshCompetition: this.getCompetitions,
            checkItem: this.checkItem,
            uncheckItem: this.uncheckItem
          }
        })
        .then(modal => {
          modal.present();
          this.modal = modal;
        });
    },
    async loadData(event) {
      try {
        await this.loadMatches({ where: 'loadData' });
      } finally {
        await event.target.complete();
      }
    },
    checkday(date){
      return this.availableDays.includes(date);
    },
    dayFormatter(dateTime) {
      // return day in format Weekday, MMM DD YYYY
      return this.moment(dateTime).tz(this.timezone).format('dddd, MMM DD YYYY');
    },
    getDatePicked(){
      if(this.pickedDate){
        const pickedDate = this.moment(this.pickedDate).format('YYYY-MM-DD');
        const today = this.moment().format('YYYY-MM-DD');
        if(pickedDate === today){
          return 'Today'
        }else{
          return this.moment(this.pickedDate).format('YYYY-MM-DD');
        }
      }
      else{
        return 'Pick a date';
      }
    },
    checkForfeit(type,status,meta,team){
      if(type === 'homeTeam'){
        if(status === 'forfeit'){
          const isForfeitingTeam = _.get(meta, 'forfeitingTeam.name') === _.get(team, 'name');
          return isForfeitingTeam ? true: false;
        }
        return false;
      }else if( type === 'awayTeam'){
        if(status === 'forfeit') {
          const isForfeitingTeam = _.get(meta, 'forfeitingTeam.name') === _.get(team, 'name');
          return isForfeitingTeam ? true: false;
        }
        return false;
      }
    },
    gameStatusColor(status) {
      switch (status) {
      case 'pre-game':
        return 'primary';
      case 'final':
        return 'success';
      case 'forfeit':
      case 'washout':
        return 'warning';
      case 'disputed':
      case 'offline':
        return 'danger';
      case 'first-half':
      case 'second-half':
      case 'first-quarter':
      case 'second-quarter':
      case 'third-quarter':
      case 'fourth-quarter':
        return 'light';
      default:
        return 'primary';
      }
    },
    gameStatusClass(status) {
      return ['first-half', 'second-half', 'first-quarter', 'second-quarter', 'third-quarter', 'fourth-quarter'].includes(status) ?
        "in-progress-box mb-05 p-10" : "mb-05 text-center flex align-center p-10";
    },
    gameStatusProgress(status) {
      return ['first-half', 'second-half', 'first-quarter', 'second-quarter', 'third-quarter', 'fourth-quarter'].includes(status)
    },
    async goMatch(id, homeTeam, awayTeam,meta,competition, competitionSettings) {
      console.log('competition', competition);
      const homeTeamId = _.get(homeTeam, '_id', undefined);
      const awayTeamId = _.get(awayTeam, '_id', undefined);
      const isVs = _.get(competitionSettings, 'type') === 'vs';
      if ((!homeTeamId || !awayTeamId) && !meta.isBye && !isVs) {
        this.$error([{message:'No Home Team or Away Team found. Please add them in the match...'}]);
        return false;
      }else if(meta.isBye){
        console.log('meta', meta);
        // creare an alert to show that this is a bye match and ask if the admin want to update the status
        const alert = await alertController
          .create({
            header: 'Alert',
            message: 'This is a BYE match, do you wish to update the match status to FINAL? Only matches with FINAL will be included in any ladder update.',
            buttons: [
              {
                text: 'Yes',
                handler: async () => {
                  const loading = await loadingController.create({ message: "Updating Match Status..." })
                  loading.present();
                  const type = 'final';
                  this.$http.put(`/assemble/api/v1/manager/matches/${id}/status`, { type })
                    .then(async (res) => {
                      loading.dismiss();
                      this.$store.commit('match/setStatus', type)
                      eventBus.emit('matchStatusUpdated', {
                        matchId: id,
                        newStatus: type
                      });
                      if(type === 'final') {
                        const alert = await alertController
                          .create({
                            header: 'Alert',
                            message: 'Do you want to Sync Ladder?',
                            buttons: [
                              {
                                text: 'Yes',
                                handler: async () => {
                                  const loading = await loadingController.create({ message: "Updating Ladder..." })
                                  loading.present();
                                  await this.$http.post(`/assemble/api/v1/manager/ladders/${competition._id}/refresh`).catch((e) => {
                                    console.log(e);
                                    loading.dismiss();
                                  });
                                  loading.dismiss();
                                }
                              },
                              {
                                text: 'No',
                                cssClass: 'secondary',
                              },
                            ],
                          });
                        await alert.present();
                      }
                    })
                    .catch((e) => {
                      loading.dismiss();
                      console.log({
                        e
                      });
                      const message = _.get(e, 'response.data.message', 'You are not allowed to update this match\'s status');
                      // $error([{message: 'You are not allowed to update this match\'s status'}]);
                      this.$error([{message: message}]);
                    })
                }
              },
              {
                text: 'No',
                cssClass: 'secondary',
              },
            ],
          });
        await alert.present();

        return false;


      }
      this.$router.push(`/matches/${id}`);
    },
    handleByeTeamClick(match) {
      console.log('match', match);
      this.goMatch(
        match._id,
        match.homeTeam,
        match.awayTeam,
        match.meta,
        match.competition,
        match.competitionSettings
      );
    },
    getTeam(status,meta){
      return status === 'forfeit'?  _.get(meta, 'forfeitingTeam.name') : '';
    },
    getScore(type, scoringEvents, scores, status, meta, team, competitionId) {
      const hasPenaltyPeriod = scoringEvents ? scoringEvents.some(ev => ev.name.toLowerCase().includes('penalty') && ev.period === 9999) : false;
      if (type === 'homeTeam' || type === 'awayTeam') {
        // if (status === 'forfeit') {
        //   const isForfeitingTeam = _.get(meta, 'forfeitingTeam.name') === _.get(team, 'name');
        //   const competition = _.find(this.competitions, { _id: competitionId });
        //   return isForfeitingTeam ? 0 : _.get(competition, 'laddertemplate.defaultScoreFFReceived');
        // }
        if (status === 'penalty' || hasPenaltyPeriod) {
          const mainScore = _.get(scores, `${type}`, 0);
          const penScoreEvents = scoringEvents
            .filter(ev =>
              ev.name.toLowerCase().includes('penalty') &&
            !ev.name.toLowerCase().includes('miss') &&
            ev.teamId === team._id
            );
          const penScore = penScoreEvents
            .reduce((acc, cur) => acc + 1, 0);
          const penScoreValues = penScoreEvents
            .reduce((acc, cur) => acc + cur.value, 0);
          return type === 'homeTeam' ? `(${penScore}) ${mainScore - penScoreValues}` : `${mainScore - penScoreValues} (${penScore})`;
        }
        return _.get(scores, `${type}`, 0);
      }
    },
  },
  watch: {
    competitionIds: {
      handler: function (newVal, oldVal) {
        this.$store.commit('page/setMatchesCompetition', newVal);
      },
      deep: true
    },
    '$route'() {
      this.processMatches('route');
    },
    // ASWL-2002: the page can stay alive across a role switch, so reset the role-scoped
    // filters and reload competitions/matches for the new role.
    '$store.state.user.activeRole._id': {
      async handler(newRoleId, oldRoleId) {
        if (!newRoleId || !oldRoleId || newRoleId === oldRoleId) return;
        this.competitionIds = null;
        this.round = undefined;
        this.rounds = [];
        this.competitions = [];
        this.checkedCompetitionFilter = [];
        await Promise.all([this.getCompetitions(), this.filterRequest()]);
        await this.processMatches('role-change');
      }
    },
  }
};
</script>
  <style>
.my-custom-alert .alert-wrapper {
  min-width:450px !important;
}
@media only screen and (max-width: 600px) {
  .my-custom-alert .alert-wrapper {
    min-width:350px !important;
  }
}
.my-custom-alert-season .alert-wrapper {
  min-width:150px !important;
  background: transparent;
}
@media only screen and (max-width: 600px) {
  .my-custom-alert-season .alert-wrapper {
    min-width:150px !important;
    background: transparent;
  }
}
</style>
<style scoped lang="scss">

.competition-order-info {
  position: relative;
  z-index: 10;
  vertical-align: middle;
  margin-left: 0.35rem;
  font-size: 1rem;
  color: var(--ion-color-medium, #92949c);
  cursor: pointer;
  pointer-events: auto;
}

.competition-order-info-popover {
  font-size: 0.85rem;
  line-height: 1.4;
}

.clear-filters {
  cursor: pointer;
  color: #333333;
  font-weight: 500;
  padding: 0.5rem;
  transition: all 0.3s ease;

  &:hover {
    text-decoration: underline;
  }
}

.competition-header {
  background-color: #0c2b34;
  padding: 10px 20px;
  margin-bottom: 0px;
  border-radius: 16px;
  color: white;
  cursor: pointer;

  @media (max-width: 1024px) {
    border-radius: 1rem;
  }
}

.competition-title {
  display: flex;
  justify-content: space-between;
  align-items: center;

  h3 {
    margin: 0;
    text-align: left;
  }

  ion-icon {
    font-size: 1.5rem;
  }
}

.date-row {
  display: flex;
  align-items: center;
  margin-left: 2rem;
  @media screen and (max-width: 1024px) {
    margin-left: 0;
    justify-content: center;
  }
}

.match-row-mobile {
  display: none;
}

@media (max-width: 1024px) {
  .match-row {
    display: none !important;
  }

  .match-row-mobile {
    display: flex;
    flex-direction: column;
    // margin-bottom: 1rem;
    border: 1px solid #ebeef5;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 6px;
    background: white;
    border-radius: 1rem;

    &:first-child {
      border-radius: 0 0 1rem 1rem;
      // margin-top: 0.5rem;
    }
    padding: 1rem;
    // margin: 0.5rem;


    .match-time, .match-round, .match-venue .match-field {
      flex: unset;
    }

    .match-time {
      font-weight: bold;
    }

    .teams-status {
      display: flex;
      justify-content: space-between;
      align-items: start;
      margin-bottom: 0.5rem;

      .team-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 30%;

        .team-logo {
          margin-bottom: 0.25rem;
        }

        .team-name {
          font-size: 14px;
          text-align: center;
        }
      }

      .match-status {
        width: 40%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .score-text {
          font-size: 18px;
          margin-bottom: 0.25rem;
        }

        ion-badge {
          font-size: 12px;
          padding: 4px 8px;
        }
      }
    }

    .match-details {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 0.5rem;
      width: 100%;
      text-align: center;
      padding: 0.5rem 0;
      border-top: 1px solid #eee;
      // border-bottom: 1px solid #eee;
      // margin-bottom: 0.5rem;

      .match-time, .match-round {
        flex: 0 0 auto;
        min-width: 0; // defend against global .match-round { min-width: 150px } so time+round stay centered on mobile
        font-size: 14px;
      }
    }

    .match-competition {
      text-align: center;
      font-size: 14px;
    }

    .match-venue {
      font-size: 14px;
      text-align: center;
    }

    .match-field {
      text-align: center;
    }
  }
}

.match-referees {
  min-width: 150px;
}

.date-filter-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
  padding: 1rem;
  background-color: #f4f5f8;

  ion-chip {
    --background: #ffffff;
    --color: #333333;
    font-weight: 500;
    cursor: pointer;

    &.active {
      --background: #0c2b34;
      --color: #ffffff;
    }

    &.date-select-chip {
      --background: #e0e0e0;
    }

    &.selected-date-chip {
      --background: #0c2b34;
      --color: #ffffff;
      display: flex;
      align-items: center;
      gap: 0.5rem;

      .clear-icon {
        font-size: 1.2rem;
        fill: white;
      }
    }
  }
}

::v-deep .hidden-input {
  display: none;
}

h3 {
  font-size: 18px;
  font-weight: 600;
  text-transform: capitalize;
  margin: 0.5rem;
}

.round-text {
  font-size: 18px;
  /* font-weight: bold; */
  font-family: 'BrownStd-Bold';
  margin-bottom: 1rem;
}

.competition-group {
  margin: 1rem 1.5rem;
  border-radius: 16px;

  .bye-teams-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 1rem;
    border-radius: 16px;
    background: white;

    @media screen and (max-width: 1024px) {
      border: 1px solid #ebeef5;
      box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 6px;
    }
    // margin: 0 0.5rem;

    // margin-bottom: 1rem;
    .bye-team {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.5rem;
      padding: 0.5rem;
      // border: 1px solid #ccc;
      border-radius: 0.5rem;

      &.clickable {
        cursor: pointer;
        transition: transform 0.2s, box-shadow 0.2s;

        &:hover {
          transform: scale(1.05);
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
        }

        &:active {
          transform: scale(0.98);
        }
      }

      .bye-status-badge {
        font-size: 0.75rem;
        padding: 0.2rem 0.5rem;
        margin-top: 0.3rem;
        text-align: center;
      }
    }
  }
}

.competition-header {
  background-color: #0c2b34;
  padding: 10px;
  margin-bottom: 0px;
  border-radius: 16px 16px 0 0;

  @media (max-width: 1024px) {
    border-radius: 1rem;
  }
  color: white;
}

.match-row {
  display: grid;
  grid-template-columns: 5rem 5rem 2fr 1.5fr 2fr 1fr;
  align-items: center;
  // gap: 1rem;
}

// iPad / tablet: keep desktop row layout (>=768px) but tighten spacing for ~768–1024px viewports
@media (min-width: 768px) and (max-width: 1024px) {
  .competition-group {
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }

  .date-row {
    margin-left: 1rem;
  }

  .date-filter-chips {
    padding: 0.75rem;
    gap: 0.35rem;

    ion-chip {
      font-size: 0.8rem;
    }
  }

  .custom-card {
    padding: 0.5rem 0;

    ::v-deep .card-content-ios {
      padding: 0.35rem 0.75rem;
    }
  }

  .match-row {
    grid-template-columns: 3.25rem 3.5rem minmax(0, 1.35fr) minmax(0, 1.05fr) minmax(0, 1.35fr) minmax(0, 0.85fr);
    column-gap: 0.35rem;

    .ml-10,
    .ml-20,
    .mr-20 {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }

  .match-time {
    font-size: 13px;
  }

  .match-round {
    min-width: 0;
    font-size: 12px;
  }

  .match-competition {
    font-size: 11px;
  }

  .team-info {
    min-width: 0;

    .team-name {
      font-size: 13px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 100%;
    }

    .team-logo {
      margin-left: 4px;
      margin-right: 4px;
    }
  }

  .match-row ::v-deep .club-logo {
    width: 2.5rem;
    height: 2.5rem;
    padding: 2px;
  }

  .match-row ::v-deep .club-logo img {
    width: 100% !important;
  }

  .match-row ::v-deep .h2h-logos {
    gap: 4px;
  }

  .match-row ::v-deep .h2h-logos .club-logo {
    width: 2rem;
    height: 2rem;
  }

  .score-text {
    font-size: 18px;
    line-height: 22px;
  }

  .match-status {
    min-width: 0;

    ion-badge {
      max-width: 4.25rem;
      height: 1.75rem;
      margin-top: 0.35rem;
      font-size: 0.65rem;
    }
  }

  .match-referees {
    min-width: 0;
    font-size: 11px;
    line-height: 1.2;

    > div:first-child {
      display: none;
    }
  }

  .match-venue {
    min-width: 0;
    font-size: 12px;

    .match-venue-name,
    .match-venue-field {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

@media (min-width: 768px) and (max-width: 834px) and (orientation: portrait) {
  .match-row {
    grid-template-columns: 2.75rem 3rem minmax(0, 1.25fr) minmax(0, 0.95fr) minmax(0, 1.25fr) minmax(0, 0.75fr);
    column-gap: 0.25rem;
  }

  .match-row ::v-deep .club-logo {
    width: 2.15rem;
    height: 2.15rem;
  }

  .team-info .team-name {
    font-size: 12px;
  }

  .score-text {
    font-size: 16px;
    line-height: 20px;
  }

  .match-status ion-badge {
    max-width: 3.75rem;
  }
}

.match-time, .match-round, .match-venue {
  flex: 0 0 15%;
}

.match-round-group {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.match-competition {
  font-size: 0.85rem;
  line-height: 1.2;
  text-transform: none;
}

.team-info {
  flex: 0 0 20%;
  display: flex;
  align-items: center;

  &.home {
    text-align: right;
    justify-content: flex-end;
  }
  &.away {
    justify-content: flex-start;
  }

  .team-logo {
    // width: 30px;
    // height: 30px;
    margin-right: 10px;
    margin-left: 10px;
  }

  .team-name {
    font-size: 16px;
    // font-weight: 600;
    font-family: 'BrownStd-Regular';
  }
}

.match-status {
  flex: 0 0 15%;
  text-align: center;

  ion-badge {
    justify-content: center;
    max-width: 5rem;
    text-align: center;
    margin: 0 auto;
    margin-bottom: 0.5rem;
    height: 2.05rem;
    margin-top: 1rem;
  }
}

ion-item {
  --padding-start: 15px;
  --padding-end: 15px;
}

.flex {
  display: flex;
}
.flex-column {
  flex-direction: column;
}
.align-center {
  align-items: center;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.light-text {
  font-size: 14px;
  font-weight: 400;
  text-transform: capitalize;
}
.normal-text {
  font-size: 15px;
  font-weight: 600;
  text-transform: capitalize;
}
.bold-text {
  font-size: 16px;
  font-weight: bold;
}
.score-text {
  font-size: 24px;
  line-height: 30px;
  font-weight: 700;
  color: rgba(8, 48, 109, 0.5);
  white-space: nowrap;
}

.header {
  --background: #1a2933 !important;
  color: white;
}

.custom-segment {
  display: flex;
  justify-content: center;
  border: none;
  background: white;
  border-radius: 0px;
}

.custom-segment ::before {
  border-left: none;
}

.custom-segment .segment-button-checked {
  color: rgb(234 68 68);
  --indicator-box-shadow: none;
  border-radius: 0;
  border-bottom: 2px solid rgb(234 68 68);
}
.custom-card {
  padding: 1rem 0;

  @media (max-width: 1024px) {
    padding: 0;
    box-shadow: none;
    background: none;
  }

  background: white;
  box-shadow: rgb(0 0 0 / 5%) 0px 0px 6px;
  cursor: pointer;
  margin: 0;

  &.bye {
    // background: #fff;
    margin-top: 0.5rem;
    position: relative;
    .bye-text {
      position: absolute;
      top: 0.5%;
      left: 2.5%;
      transform: translate(-50%, 0%);
      font-size: 12px;
      font-weight: 600;
      background: #EE6563;
      color: white;
      padding: 0.25rem 0.5rem;
      border-radius: 0.5rem;
      font-family: 'BrownStd-Bold';
    }

    @media (max-width: 1024px) {
      .bye-text {
        position: absolute;
        top: 2.5%;
        left: 10%;
        transform: translate(-50%, 0%);
        font-size: 12px;
        font-weight: 600;
        background: #EE6563;
        color: white;
        padding: 0.25rem 0.5rem;
        border-radius: 0.5rem;
        font-family: 'BrownStd-Bold';
      }
    }
  }
}
.custom-card .card-content-ios {
  padding: 0.5rem 1.5rem;
  p {
    // margin: 0px;
  }
  @media (max-width: 1024px) {
    padding: 0;
    margin-bottom: 0.5rem;
  }
}

.card-content-md {
  padding-inline-start: 0px;
  padding-inline-end: 0px;
  padding-bottom: 0px;
}

.date-picker-div {
  max-width: 20rem;
}

.filter-list {
  height: auto;
}

.filter-list.close {
  height: 0px;
}

.filter-toggle-row {
  padding: 0;
}

.date-row-comp {
  margin-top: 1rem;
}
</style>
